import { useMutation } from '@tanstack/react-query';

import type { DeleteEmployeeChildArgs } from '../../../Domain/Employees/Services/EmployeeService';
import { employeeService } from '../../../Domain/Employees/Services/EmployeeService';

const mutationFn = (data: DeleteEmployeeChildArgs) => {
  return employeeService.deleteEmployeeChild(data);
};

export const useEmployeeDeleteChildMutation = () => {
  return useMutation<unknown, unknown, DeleteEmployeeChildArgs>(mutationFn);
};
